import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(({ spacing }) => ({
  subSectionTitle: {
    margin: 0,
    lineHeight: 1.5,
    fontWeight: "bold",
    paddingLeft: 32,
  },
  subSectionWrapper: {
    border: `solid 2px ${colors.grayMedLight}`,
  },
  subSection: {
    padding: 32,
  },
}));

export default useStyles;
